import React from 'react'
import Button from '@material-ui/core/Button'
import moment from 'moment'
import hamburger from 'assets/images/food/hamburger.jpeg'
import plums from 'assets/images/food/plums.jpeg'
import tomatoes from 'assets/images/food/tomatoes.jpeg'
import carrots from 'assets/images/food/carrots.jpeg'
import spaghettiBolgnese from 'assets/images/recipes/spaghettiBolognese.jpeg'
import baconAndEggs from 'assets/images/recipes/baconAndEggs.jpeg'
import Chip from '@material-ui/core/Chip'

const today = moment().format()

export const salutations = [
  {name: 'Mr'},
  {name: 'Mrs'},
  {name: 'Ms'},
  {name: 'Miss'},
  {name: 'Dr'},
  {name: 'Professor'},
]

export const todays_orders = [
  {orderCount: 10, status: 'any', scheduled_at: 'today'},
  {orderCount: 10, status: 'pending', scheduled_at: 'today'},
  {orderCount: 10, status: 'ready_to_go', scheduled_at: 'today'},
  {orderCount: 10, status: 'in_transit', scheduled_at: 'today'},
  {orderCount: 10, status: 'complete', scheduled_at: 'today'},
  {orderCount: 10, status: 'cencelled', scheduled_at: 'today'},
]

export const todays_orders_by_transport = [
  {direction: 'donor_dropoff', transport_by_warehouse_company: true, scheduled_at: today}, // donor_pickup
  {direction: 'donor_dropoff', transport_by_warehouse_company: false, scheduled_at: today}, // donor_delivery
  {direction: 'beneficiary_pickup', transport_by_warehouse_company: true, scheduled_at: today}, // // beneficiary_dropoff
  {direction: 'beneficiary_pickup', transport_by_warehouse_company: false, scheduled_at: today}, // // beneficiary_collection
]

export const servings = [
    {id: 1, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaisse', people_served:305},
    {id: 2, date: '27/01/2021', meal: 'Lunch', recipe: 'Beef Stew', people_served: 247},
    {id: 3, date: '27/01/2021', meal: 'Dinner', recipe: 'Macaroni Cheese', people_served: 298},
    {id: 4, date: '27/01/2021', meal: 'Breakfast', recipe: 'Bacon & Eggs', people_served: 324},
    {id: 5, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 312},
    {id: 6, date: '27/01/2021', meal: 'Dinner', recipe: 'Lasagne', people_served: 214},
    {id: 7, date: '27/01/2021', meal: 'Dinner', recipe: 'Chicken Curry', people_served: 378},
    {id: 8, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 412},
    {id: 9, date: '27/01/2021', meal: 'Dinner', recipe: 'Lentil Dal', people_served: 219},
    {id: 10, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 356},
    {id: 11, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 289},
    {id: 12, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 276},
    {id: 13, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 254},
    {id: 14, date: '27/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 319},
    {id: 15, date: '28/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 312},
    {id: 16, date: '28/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 314},
    {id: 17, date: '29/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 216},
    {id: 18, date: '29/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 317},
    {id: 19, date: '30/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 368},
    {id: 20, date: '30/01/2021', meal: 'Dinner', recipe: 'Spaghetti Bolognaise', people_served: 399},
]

export const beneficiaries = [
  {id: 1, photo: <img src="https://randomuser.me/api/portraits/women/59.jpg" width={100}/>, name: "Maria Green", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 23, meals_last_7_days: 8},
  {id: 2, photo: <img src="https://randomuser.me/api/portraits/men/23.jpg" width={100}/>, name: "Peter White" , last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 17, meals_last_7_days: 0},
  {id: 3, photo: <img src="https://randomuser.me/api/portraits/women/15.jpg" width={100}/>, name: "Lucia Black", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 12, meals_last_7_days: 1},
  {id: 4, photo: <img src="https://randomuser.me/api/portraits/women/17.jpg" width={100}/>, name: "Charlotte Grey", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 7, meals_last_7_days: 7},
  {id: 5, photo: <img src="https://randomuser.me/api/portraits/men/38.jpg" width={100}/>, name: "Edward Pink", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 8, meals_last_7_days: 3},
  {id: 6, photo: <img src="https://randomuser.me/api/portraits/men/7.jpg" width={100}/>, name: "Sam Brown", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 16, meals_last_7_days: 4},
  {id: 7, photo: <img src="https://randomuser.me/api/portraits/women/18.jpg" width={100}/>, name: "Twyla Yellow", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 98, meals_last_7_days: 5},
  {id: 8, photo: <img src="https://randomuser.me/api/portraits/women/57.jpg" width={100}/>, name: "Alexis Rose", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 34, meals_last_7_days: 6},
  {id: 9, photo: <img src="https://randomuser.me/api/portraits/men/23.jpg" width={100}/>, name: "David Orange", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 54, meals_last_7_days: 1},
  {id: 10, photo: <img src="https://randomuser.me/api/portraits/women/16.jpg" width={100}/>, name: "Richard Green", last_meal: '27/01/2021', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 13, meals_last_7_days: 2},
]

export const cartProducts = [
  {id: 1, photo: <img src={hamburger} width={50}/>, name: "Hamburgers", qty: 3},
  {id: 2, photo: <img src={plums} width={50}/>, name: "Plums", qty: 5},
  {id: 3, photo: <img src={tomatoes} width={50}/>, name: "Tomatoes", qty: 7},
  {id: 4, photo: <img src={carrots} width={50}/>, name: "Carrots", qty: 2},
]

export const orderTypes = [
  {name: 'beneficiary_dropoff', label: 'Beneficiary Dropoff', company_type: 'beneficiary', task: 'dropoff'},
  {name: 'beneficiary_collection', label: 'Beneficiary Collection', company_type: 'beneficiary', task: 'collection'},
  {name: 'donor_pickup', label: 'Donor Pickup', company_type: 'donor', task: 'pickup'},
  {name: 'donor_delivery', label: 'Donor Delivery', company_type: 'donor', task: 'delivery'}
]

export const meals = [
  {id: 1, date: "30/03/2021", time: "17:00", photo: <img src={spaghettiBolgnese} width={50}/>, meal:"Dinner", name: "Spaghetti Bolgnese", expected_people: 312, status: <Chip size="small" label="pending" style={{backgroundColor: "#42a5f5"}} />, serve: <Button variant="contained">Serve Now</Button>},
  {id: 2, date: "29/03/2021", time: "09:00",  photo: <img src={baconAndEggs} width={50}/>, meal:"Dinner", name: "Bacon & Eggs", expected_people: 215, status: <Chip size="small" label="active" color="secondary" />},
  {id: 2, date: "29/03/2021", time: "09:00",  photo: <img src={baconAndEggs} width={50}/>, meal:"Dinner", name: "Bacon & Eggs", expected_people: 207, status: <Chip size="small" label="closed" />},
  {id: 2, date: "28/03/2021", time: "09:00",  photo: <img src={baconAndEggs} width={50}/>, meal:"Dinner", name: "Bacon & Eggs", expected_people: 183, status: <Chip size="small" label="closed" />},
]

export const recipes = [
  {
    id: 1, //int
    created: "30/03/2021", // datetime
    created_by: "Manu", // user_id
    img: "/static/images/recipes/paella.jpg", // blob
    name: "Paella", //string 255
    description: "This impressive paella is a perfect party dish and a fun meal to cook together with your guests. Add 1 cup of frozen peas along with the mussels, if you like.", // longtext
    ingredients: [
      {id: 1, name: "olive oil", type: "", uom: "tablespoon", qty: 6, preparation: "" },
      {id: 2, name: "paprika", type: "", uom: "tablespoon", qty: 1, preparation: "" },
      {id: 3, name: "oregano", type: "dried", uom: "teaspoon", qty: 2, preparation: "" },
      {id: 4, name: "salt", type: "", uom: "", qty: 1, preparation: "" },
      {id: 5, name: "pepper", type: "", uom: "", qty: 2, preparation: "" },
      {id: 6, name: "chicken",  type: "breasts", uom: "pound", qty: 2, preparation: "skinned and deboned" },
      {id: 7, name: "garlic", type: "", uom: "cloves", qty: 3, preparation: "" },
      {id: 8, name: "red pepper", type: "flakes", uom: "teaspoon", qty: 1, preparation: "crushed" },
      {id: 9, name: "rice", type: "short grain white", uom: "cups", qty: 2, preparation: "uncooked" },
      {id: 10, name: "saffron threads", type: "", uom: "pinch", qty: 1, preparation: "" },
      {id: 11, name: "bay leaf", type: "", uom: "", qty: 1, preparation: "" },
      {id: 12, name: "parsley", type: "Italian flat leaf", uom: "bunch", qty: 0.5, preparation: "" },
      {id: 13, name: "chicken stock", type: "", uom: "quart", qty: 1, preparation: "" },
      {id: 14, name: "lemons", type: "", uom: "", qty: 2, preparation: "" },
      {id: 15, name: "onion", type: "Spanish", uom: "", qty: 1, preparation: "" },
      {id: 16, name: "red bell pepper", type: "", uom: "", qty: 1, preparation: "" },
      {id: 17, name: "chorizo sausage", type: "", uom: "pound", qty: 1, preparation: "casings removed and crumbled" },
      {id: 18, name: "shrimp", uom: "pound", qty: 1, preparation: "peeled and deveined" },
    ],
    steps: [
      {id: 1,description: "In a medium bowl, mix together 2 tablespoons olive oil, paprika, oregano, and salt and pepper. Stir in chicken pieces to coat. Cover, and refrigerate."},
      {id: 2,description: "Heat 2 tablespoons olive oil in a large skillet or paella pan over medium heat. Stir in garlic, red pepper flakes, and rice. Cook, stirring, to coat rice with oil, about 3 minutes. Stir in saffron threads, bay leaf, parsley, chicken stock, and lemon zest. Bring to a boil, cover, and reduce heat to medium low. Simmer 20 minutes."},
      {id: 3,description: "Meanwhile, heat 2 tablespoons olive oil in a separate skillet over medium heat. Stir in marinated chicken and onion; cook 5 minutes. Stir in bell pepper and sausage; cook 5 minutes. Stir in shrimp; cook, turning the shrimp, until both sides are pink."},
      {id: 4,description: "Spread rice mixture onto a serving tray. Top with meat and seafood mixture."},
    ],
    preparation_time: 60,
    cooking_time: 45,
    total_time: 105,
    number_of_servings: 6,
  }
]

export const nutrition = [
  { id: 1, name: "Protein", value: 55.7, uom: "g", percent_daily_value: 111 }, // name=nutrition_type which holds fields percent_daily_value & uom
  { id: 2, name: "Carbohydrates", value: 45.7, uom: "g", percent_daily_value: 15 },
  { id: 3, name: "Dietary Fiber", value: 2.9, uom: "g", percent_daily_value: 12 },
  { id: 4, name: "Sugars", value: 1.9, uom: "g", percent_daily_value: "" },
  { id: 5, name: "Fat", value: 35.1, uom: "g", percent_daily_value: 54 },
  { id: 6, name: "Saturated Fat", value: 202.5, uom: "mg", percent_daily_value: 68 },
  { id: 7, name: "Cholesterol", value: 35.1, uom: "g", percent_daily_value: 54 },
  { id: 8, name: "Vitamin A Iu", value: 1543.7, uom: "IU", percent_daily_value: 31 },
  { id: 9, name: "Niacin Equivalents", value: 27.9, uom: "g", percent_daily_value: 215 },
  { id: 10, name: "Vitamin B6", value: 1.2, uom: "mg", percent_daily_value: 75 },
  { id: 11, name: "Vitamin C", value: 31, uom: "g", percent_daily_value: 52 },
  { id: 12, name: "Folate", value:140.7, uom: "mcg", percent_daily_value: 35 },
  { id: 13, name: "Calcium", value: 73.2, uom: "mg", percent_daily_value: 7 },
  { id: 14, name: "Iron", value: 6.1, uom: "mg", percent_daily_value: 34 },
  { id: 15, name: "Magnesium", value: 83.6, uom: "mg", percent_daily_value: 30 },
  { id: 16, name: "Potassium", value: 778.1, uom: "mg", percent_daily_value: 22 },
  { id: 17, name: "Sodium", value: 1204.2, uom: "mg", percent_daily_value: 48 },
  { id: 18, name: "Thiamin", value: 0.8, uom: "mg", percent_daily_value: 76 },
  { id: 19, name: "Calories From Fat", value: 316.1, uom: "", percent_daily_value: "" },
]

export const companies = [
  { company_type: 'beneficiary', name: 'CBD Helping Hands', slug: 'cbd-helping-hands', map_image: "logo.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -26.358055, lng: 27.398056 },
  { company_type: 'beneficiary', name: 'Siphosethu Nxawe', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -29.100000, lng: 26.216700 },
  { company_type: 'beneficiary', name: 'Lazarus Ministries', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -29.883333, lng: 31.049999 },
  { company_type: 'beneficiary', name: 'MES Hillbrow', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -26.266111, lng: 27.865833 },
  { company_type: 'beneficiary', name: 'New Living Hope', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -29.087217, lng: 26.154898 },
  { company_type: 'beneficiary', name: 'Mosadie Gives Back', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.958252, lng: 25.619022 },
  { company_type: 'beneficiary', name: 'Noluthando Toddlers', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.563404, lng: 27.844164 },
  { company_type: 'beneficiary', name: 'Ladles of Love', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.977074, lng: 22.457581 },
  { company_type: 'beneficiary', name: 'Service Dining Rooms', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.120134, lng: 27.901464 },
  { company_type: 'beneficiary', name: 'Abaphumeledi Home of Safety', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -25.872782, lng: 29.255323 },
  { company_type: 'beneficiary', name: 'Philisa Abafazi Bethu- Gigi', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.205681, lng: 28.046822 },
  { company_type: 'beneficiary', name: 'Vryburg', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.958405, lng: 24.729860 },
  { company_type: 'beneficiary', name: 'Robertsham', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.245167, lng: 28.015680 },
  { company_type: 'beneficiary', name: 'Hermanus', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-34.414272, lng: 19.248734 },
  { company_type: 'beneficiary', name: 'Klerksdorp, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.859823, lng: 26.631750 },
  { company_type: 'beneficiary', name: 'Boksburg, Gauteng, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.232590, lng: 28.240967 },
  { company_type: 'beneficiary', name: 'Mahikeng, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-25.853161	, lng: 25.640181 },
  { company_type: 'beneficiary', name: 'Vanderbijlpark, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.703421, lng:	27.807695 },
  { company_type: 'beneficiary', name: 'Berea, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-29.851847, lng: 30.993368 },
  { company_type: 'beneficiary', name: 'Super Duper Beneficiary', slug: 'cbd-helping-hands', map_image: "cbd-helping-hands-map.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-28.741943, lng: 24.771944 },
  { company_type: 'beneficiary', name: 'Centurion, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-25.850187, lng: 28.198042 },
  { company_type: 'beneficiary', name: 'Summerstrand, Port Elizabeth, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.991360, lng: 25.656912 },
  { company_type: 'beneficiary', name: 'Kraaifontein, Cape Town, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.844166, lng: 18.698610 },
  { company_type: 'beneficiary', name: 'Sasolburg, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.810190, lng: 27.827724 },
  { company_type: 'beneficiary', name: 'Umlazi, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-29.967422, lng: 30.882959 },
  { company_type: 'beneficiary', name: 'Milnerton, Cape Town, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.866669, lng:18.500000 },
  { company_type: 'beneficiary', name: 'Stellenbosch, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.932106, lng:	18.860151 },
  { company_type: 'beneficiary', name: 'Rustenburg, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-25.654448, lng:	27.255854 },
  { company_type: 'beneficiary', name: 'Vereeniging, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.673611, lng:	27.931944 },
  { company_type: 'donor', name: 'Famous Brands', slug: 'famous-brands', website: 'https://famousbrands.co.za/', map_image: "famous-brands-map.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-27.644606, lng:	27.250900 },
  { company_type: 'beneficiary', name: 'Emalahleni, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-25.872782, lng:	29.255323 },
  { company_type: 'beneficiary', name: 'Randburg, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.093611, lng:	28.006390 },
  { company_type: 'beneficiary', name: 'Kwa Nobuhle, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.811775, lng:	25.384497 },
  { company_type: 'beneficiary', name: 'Pretoria, Gauteng, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-25.731340, lng:	28.218370 },
  { company_type: 'beneficiary', name: 'Sandton, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.107567, lng:	28.056702 },
  { company_type: 'beneficiary', name: 'Kempton Park, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.100000, lng:	28.233334 },
  { company_type: 'logistics', name: 'Amazing Logistics Partner', slug: 'amazing-logistics-partner', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:-34.035088, lng:	23.046469 },
  { company_type: 'beneficiary', name: 'Paarl, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.715546, lng:	18.966248 },
  { company_type: 'beneficiary', name: 'Johannesburg, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-26.195246, lng:	28.034088 },
  { company_type: 'beneficiary', name: 'Cape Town, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-33.918861, lng:	18.423300 },
  { company_type: 'beneficiary', name: 'Pinetown, South Africa', slug: 'cbd-helping-hands', map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 25000, total_meals: 800, last_donation_date: '26 March 2021', last_donation_weight: 120, lat:	-29.806988, lng:	30.853558 },
]

export const beneficiary_company = {
  name: 'CBD Helping Hands',
  slug: 'cbd-helping-hands',
  company_type: 'beneficiary',
  description: '<p>CBD Helping Hands was born in 1992 when Charlene helped Pastor Alan Africa hand out food in Mitchell\'s plain.  This continued for many years. In 2014 Charlene volunteered with different schools where they offered programs for youth upliftment. This continued until 2018 when she started an aftercare program - Learning with Fun.  "Learning to read is one of the most important skills children can learn" says Charlene.<br />Reading  makes the learning journey more  fun and interactive. It is so rewarding to to celebrate a child\'s first words and steps and then to see them learn to read their very first book. </p><p>Our center will have the following:<ul><li>Cooking facilities</li><li>Reading library</li><li>Bathroom facilities</li><li>Sports</li><li>Academics</li><li>Skills and development</li></ul></p><p>Charlene wants the centre to provide social development and be registered with the Department of Social Development as well as Child Care and Protection Services.</p><p>Charlene wants the centre to be a safe place for children to come and spend their time, to be happy and learn. She wants all the kids that pass through the centre to become independent and self-sufficient.</p><p>At the onset of Covid19 Charlene and her family realised that their community was starting we had to recreate our centre into a soup kitchen. Where we  do our cooking to serve the community of Leiden Delft Mfuleni Happy Valley and The Conifers, Kalkfontein and now Kalsteenfontein.</p>',
  logo: 'logo.jpg',
  map_image: 'cbd-helping-hands_map.jpg',
  banner: "cbd-helping-hands-banner.jpg",
  type: "Early Childhood Development Centre",
  province: "Western Cape",
  recipients: 315 ,
  last_donation_value: 25000,
  total_meals: 800,
  last_donation_date: '26 March 2021',
  last_donation_weight: null,
  total_kilometres_driven: null,
  registered_npo: true,
  status: 'active',
  vetting_status: 'complete',
  npo_number: '12345',
  images: [
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05466_kwlv0n.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05621_zgtcco.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05513_gfbiwi.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05588_nb0dma.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05459_ziuomy.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05586_oj8jfo.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05465_dtkwef.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05626_ytsf3j.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05449_l9kukz.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05544_aczrb9.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05447_mvffor.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05501_yirmq8.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05624_f5b2ud.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05623_dcpfva.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05515_d2gzut.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05581_ceocwv.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05517_ni2k0p.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05620_qfwycq.jpg", alt: "", title: "" },
  ],
  core_business: [
    {id: 1, name: "Food relief"},
    {id: 2, name: "Early Childhood Development (ECD)"},
  ],
  contacts: [
    {id: 1, name: 'Charlene', email: 'charlene@company.com', mobile: '0761234567', position: 'General Manager', profile_pic: '/static/images/beneficiaries/contacts/charlene.jpg', is_default: true, description: 'This is a biographical desciption of this contact'},
    {id: 2, name: 'Bert', email: 'bert@company.com', mobile: '0763218765', position: 'Sustainability Manager', profile_pic: '/static/images/beneficiaries/contacts/bert.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
    {id: 3, name: 'Chelynn', email: 'chelynn@company.com', mobile: '0793218423', position: 'Warehouse Manager', profile_pic: '/static/images/beneficiaries/contacts/chelynn.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
  ],
  addresses: [
    { lat: -26.358055, lng: 27.398056, primary: true, city: 'Cape Town'}
  ],
  donations: [
    {order_id: 1, donor: 'Nestle', total_weight: 324},
    {order_id: 2, donor: 'Famous Brands', total_weight: 516},
    {order_id: 3, donor: 'Denny Mushrooms', total_weight: 432},
  ]
}

export const donor_company = {
  name: 'Famous Brands',
  slug: 'famous-brands',
  company_type: 'donor',
  description: '<p>Famous Brands is Africa’s leading branded food services franchisor.</p><p>The Group’s origins date back to the early 1960s, with the founding of a humble family business comprising one brand, Steers, and a limited supply chain. Today our enterprise consists of an extensive, vertically integrated business model, with trading operations on three continents.</p><p>In 1994 the holding company listed on the JSE Limited in the Travel and Leisure sector.</p>',
  city: "Cape Town",
  province: "Western Cape",
  last_donation_value: 25000,
  beneficiary_total_meals_received: null,
  donor_total_meals_donated: 800,
  last_donation_date: '26 March 2021',
  last_donation_weight: 120,
  beneficiary_status: null,
  donor_status: 'active',
  logistics_status: 'active',
  logistics_total_distance_driven: null,
  beneficiary_recipients: null, // integer
  beneficiary_registered_npo: null, // bool
  beneficiary_vetting_status: null, // string
  npo_number: null, // string
  video: '', // youtube url
  website: 'https://famousbrands.co.za/',
  logo: "famous-brands-logo.png", // string
  banner: "famous-brands-banner.jpg", // string
  images: [
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05466_kwlv0n.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05621_zgtcco.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05513_gfbiwi.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05588_nb0dma.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05459_ziuomy.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05586_oj8jfo.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05465_dtkwef.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05626_ytsf3j.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05449_l9kukz.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05544_aczrb9.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05447_mvffor.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05501_yirmq8.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05624_f5b2ud.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05623_dcpfva.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05515_d2gzut.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05581_ceocwv.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05517_ni2k0p.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05620_qfwycq.jpg", alt: "", title: "" },
  ],
  core_business: [
    {id: 1, name: "Manufacturing"},
    {id: 2, name: "Logistics"},
  ],
  contacts: [
    {id: 1, name: 'Charlene', email: 'charlene@company.com', mobile: '0761234567', position: 'General Manager', profile_pic: '/static/images/beneficiary/contacts/charlene.jpg', is_default: true, description: 'This is a biographical desciption of this contact'},
    {id: 2, name: 'Bert', email: 'bert@company.com', mobile: '0763218765', position: 'Sustainability Manager', profile_pic: '/static/images/beneficiary/contacts/bert.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
    {id: 3, name: 'Chelynn', email: 'chelynn@company.com', mobile: '0793218423', position: 'Warehouse Manager', profile_pic: '/static/images/beneficiary/contacts/chelynn.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
  ],
  addresses: [
    { lat: -26.358055, lng: 27.398056, primary: true, city: 'Cape Town'}
  ],
  donations: [
    {order_id: 1, donor: 'Nestle', total_weight: 324},
    {order_id: 2, donor: 'Famous Brands', total_weight: 516},
    {order_id: 3, donor: 'Denny Mushrooms', total_weight: 432},
  ]
}

export const logistics_company = {
  name: 'Time Link Cargo',
  slug: 'time-link-cargo',
  company_type: 'logistics',
  description: '<p>Privately owned logistics company, Time Link Cargo, services clients nationwide. With our Head office based in Cape Town and branches across the country, we are able to offer our clients a variety of professional services including long distance transport, dedicated contracts and warehousing. Time Link Cargo is renowned for our innovative introductions, logistical solutions and efficient controls. These, bolstered by our supremely consumer-centred attitude and a highly motivated team, ensure that our clients don’t merely do business with us but instead become our business partners.</p><h3>WHY CHOOSE US</h3><ol><li><u>UNCOMPROMISING COMMITMENT</u><br />We are able to meet the diverse needs and preferences of our individual clients, ensuring a mutual understanding and uncompromising commitment to getting the job done right, the first time!</li><li><u>STRATEGIC PLANNING</u><br />Our sound strategic planning and clear objectives ensure that we not only meet, but also exceed client expectations and standards.</li><li><u>STRICT COMPLIANCE</u><br />Time Link Cargo has established exceptionally high standards when it comes to operational criteria that follow strict compliance with legislation.</li><li><u>REPUTATION</u><br />Time Link Cargo’s outstanding industry reputation for innovative introductions, logistical solutions and efficient controls is bolstered by a supremely consumer-centred attitude and a highly motivated team.</li><li><u>24-HOUR MONITORING</u><br />Our 24-hour manned control room operates throughout the year, offering real-time vehicle tracking and live integrated cameras. This capability ensures that proper routes are followed, driving hours are adhered to, and that drivers sleep in allocated areas which safeguards our fleet against accidents relating to driver fatigue, hijacking and load tampering.</li><li><u>HANDS-ON TEAM</u><br />The directors, management and staff at Time Link Cargo continually strive to improve service levels to our clients by ensuring that we are hands-on every step of the way. Our focus on long-term partnerships is based on the delivery of a safe and reliable service.</li><ul>',
  city: "Cape Town",
  province: "Western Cape",
  last_donation_value: 25000,
  beneficiary_total_meals_received: null,
  donor_total_meals_donated: 800,
  last_donation_date: '26 March 2021',
  last_donation_weight: 120,
  beneficiary_status: null,
  donor_status: 'active',
  logistics_status: 'active',
  logistics_total_distance_driven: 65847,
  beneficiary_recipients: null, // integer
  beneficiary_registered_npo: null, // bool
  beneficiary_vetting_status: null, // string
  npo_number: null, // string
  video: "https://www.youtube.com/embed/EOGqaNzh0Ns", // youtube url
  logo: "logo.png", // string
  website: "https://timelinkcargo.com/",
  banner: "time-link-banner.jpg", // string
  images: [
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05466_kwlv0n.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05621_zgtcco.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05513_gfbiwi.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05588_nb0dma.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05459_ziuomy.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05586_oj8jfo.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05465_dtkwef.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05626_ytsf3j.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05449_l9kukz.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05544_aczrb9.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05447_mvffor.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05501_yirmq8.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05624_f5b2ud.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05623_dcpfva.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05515_d2gzut.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05581_ceocwv.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05517_ni2k0p.jpg", alt: "", title: "" },
    {src:"https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05620_qfwycq.jpg", alt: "", title: "" },
  ],
  core_business: [
    {id: 1, name: "Logistics"},
  ],
  contacts: [
    {id: 1, name: 'Peter van der Westhuisen', email: 'peter@company.com', mobile: '0761234567', position: 'General Manager', profile_pic: '/static/images/beneficiary/companies/contacts/charlene.jpg', is_default: true, description: 'This is a biographical desciption of this contact'},
    {id: 2, name: 'Edward Swartberg', email: 'edward@company.com', mobile: '0763218765', position: 'Sustainability Manager', profile_pic: '/static/images/companies/beneficiary/contacts/bert.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
    {id: 3, name: 'Carol Meyers', email: 'carol@company.com', mobile: '0793218423', position: 'Warehouse Manager', profile_pic: '/static/images/companies/beneficiary/contacts/chelynn.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
  ],
  addresses: [
    { lat: -26.358055, lng: 27.398056, primary: true, city: 'Cape Town'}
  ],
  donations: [
    {order_id: 1234, donor: 'Nestle', total_weight: 324},
    {order_id: 1234, donor: 'Famous Brands', total_weight: 516},
    {order_id: 1234, donor: 'Denny Mushrooms', total_weight: 432},
  ]
}

export const donations = [
  {id: 31, date: '26/03/2021', weight: 345, value: 3247, status: 'pending', section18a_status: 'generated'},
  {id: 32, date: '25/03/2021', weight: 678, value: 1259, status: 'active', section18a_status: 'not_generated' },
  {id: 33, date: '24/03/2021', weight: 760, value: 4678, status: 'complete', section18a_status: 'pending_donation_completion'},
  {id: 34, date: '23/03/2021', weight: 550, value: 9231, status: 'complete', section18a_status: 'generated'},
  {id: 35, date: '22/03/2021', weight: 600, value: 6580, status: 'complete', section18a_status: 'generated'},
  {id: 36, date: '21/03/2021', weight: 1500, value: 3350, status: 'complete', section18a_status: 'generated'},
]

export const branches = [
  { name: 'Branch 1', city: "Cape Town", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 1234, last_donation_date: '26 March 2021', last_donation_weight: 120, lat: -26.358055, lng: 27.398056, is_default: "Peter Andrews", open_tickets: 3 },
  { name: 'Branch 2', city: "Cape Town", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 5678, last_donation_date: '22 March 2021', last_donation_weight: 120, lat: -29.100000, lng: 26.216700,  is_default: "Lily Petersen", open_tickets: 0 },
  { name: 'Branch 3', city: "Johannesburg", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 986, last_donation_date: '21 March 2021', last_donation_weight: 120, lat: -29.883333, lng: 31.049999, is_default: "Jan van Riebeek", open_tickets: 0 },
  { name: 'Branch 4', city: "Cape Town", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 678, last_donation_date: '16 March 2021', last_donation_weight: 120, lat: -26.266111, lng: 27.865833, is_default: "Sipo Bukize", open_tickets: 0 },
  { name: 'Branch 5', city: "Durban", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 2860, last_donation_date: '12 March 2021', last_donation_weight: 120, lat: -29.087217, lng: 26.154898, is_default: "Ed Sheerhan", open_tickets: 0},
  { name: 'Branch 6', city: "Bloemfontein", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 7940, last_donation_date: '9 March 2021', last_donation_weight: 120, lat:	-33.958252, lng: 25.619022, is_default: "Amy Rodriguez", open_tickets: 0 },
  { name: 'Branch 7', city: "Nelspruit", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 21340, last_donation_date: '3 February 2021', last_donation_weight: 120, lat:	-26.563404, lng: 27.844164, is_default: "Jonah Dawson", open_tickets: 0},
  { name: 'Branch 8', city: "Durban", map_image: "beneficiary_infowindow_example.jpg", type: "Early Childhood Development Centre", province: "Western Cape", recipients: "Western Cape", recipients: 315 , last_donation_value: 8267, last_donation_date: '8 January 2021', last_donation_weight: 120, lat:	-33.977074, lng: 22.457581, is_default: "Solomon Liebermann", open_tickets: 0 },
]

export const lastDonation = [
  {id: 31, date: '26/03/2021', weight: 345, value: 3247, status: 'pending'}
]

export const tickets = [
  {id: 1, subject: "Sample Ticket 1: This is a sample", requester: "Peter Parker", branch: 'Head Office', requested: "14 minutes ago", updated: "14 minutes ago", type: "incident", status: "unsolved", priority: "normal", assignee: "Manu Wegmershaus"},
  {id: 2, subject: "Sample Ticket 2: This is another sample", requester: "Sipo Bukize", branch: 'Branch 1', requested: "3 hours ago", updated: "1 hour ago", type: "incident", status: "new", priority: "urgent", assignee: "Manu Wegmershaus"},
  {id: 3, subject: "Sample Ticket 3: This is yet another sample", requester: "Ed Sheerhan", branch: 'Branch 7', requested: "2 days ago", updated: "3 ago", type: "incident", status: "pending", priority: "normal", assignee: "Manu Wegmershaus"}
]

export const payment_options = [
  {name: "eft", label: "EFT", icon: ""},
  {name: "paypal", label: "PayPal", icon: ""},
  {name: "payfast", label: "PayFast", icon: ""},
  {name: "snapscan", label: "SnapScan", icon: ""},
]

export const projects = [
  {name: "any", label: "Any", project_id: ""},
  {name: "technology", label: "Technology Platform", project_id: ""},
  {name: "legal", label: "Legal costs", project_id: ""},
  {name: "warehousing", label: "Warehousing", project_id: ""},
  {name: "vehicles", label: "Vehicles", project_id: ""},
  {name: "salaries", label: "Salaries", project_id: ""},
]

export const recurring_payment_periods = [
  {name: 'weekly', label: "Weekly"},
  {name: 'monthly', label: "Monthly"},
  {name: 'annually', label: "Annually"},
]

export const contacts = [
  {id: 1, name: 'Peter Parker', email: 'peter@company.com', mobile: '0761234567', position: 'General Manager', profile_pic: '/static/images/contacts/man-placeholder.jpg', is_default: true, description: 'This is a biographical desciption of this contact'},
  {id: 2, name: 'Linda Shongwe', email: 'linda@company.com', mobile: '0763218765', position: 'Sustainability Manager', profile_pic: '/static/images/contacts/woman-placeholder.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
  {id: 3, name: 'Jannie van der Westhuisen', email: 'jannie@company.com', mobile: '0793218423', position: 'Warehouse Manager', profile_pic: '/static/images/contacts/man-placeholder.jpg', is_default: false, description: 'This is a biographical desciption of this contact'},
]

export const addresses = [
  {id: 1, name: 'Bidfoods Head Office', type: 'Head Office', lat: -33.9592982, lng: 18.5889701, google_address: 'Bahrain Dr, Airport Industria, Cape Town, 7490', is_default: true},
  {id: 2, name: 'DC 1', type: 'Warehouse', lat: -33.9593091, lng: 18.588962, google_address: '7490, Matroosfontein, Cape Town', is_default: false},
]

export const provinces = [
  {name: "Eastern Cape", value: "EC", capital: "Bhisho", population: 6562053 },
  {name: "Free State", value: "FS", capital: "Bloemfontein", population: 2745590 },
  {name: "Gauteng", value: "GP", capital: "Johannesburg", population: 12272263 },
  {name: "Kwazulu Natal", value: "KZN", capital: "Pietermaritzburg", population: 10267300 },
  {name: "Limpopo", value: "LP", capital: "Polokwane", population: 5404868 },
  {name: "Mpumalanga", value: "MP", capital: "Mbombela", population: 4039939 },
  {name: "North West", value: "NW", capital: "Mahikeng", population: 3509953 },
  {name: "Northern Cape", value: "NC", capital: "Kimberley", population: 1145861 },
  {name: "Western Cape", value: "WC", capital: "Cape Town", population: 5822734 },
]

export const company_core_business = [
  {id: 1, company_type: 'donor', value: 'agriculture', name: 'Agriculture', description: 'Raising crops, livestock, and seafood', slug: 'agriculture'},
  {id: 2, company_type: 'donor', value: 'manufacturing', name: 'Manufacturing', description: 'Agrichemicals, agricultural construction, farm machinery and supplies, seed, etc.', slug: 'manufacturing'},
  {id: 3, company_type: 'donor', value: 'food_processing', name: 'Food processing', description: 'Preparation of fresh products for market, and manufacture of prepared food products', slug: 'food-processing'},
  {id: 4, company_type: 'donor', value: 'marketing', name: 'Marketing', description: 'Promotion of generic products (e.g., milk board), new products, advertising, marketing campaigns, packaging, public relations, etc.', slug: 'marketing'},
  {id: 5, company_type: 'donor', value: 'wholesesale', name: 'Wholesesale', description: 'The sales of goods or services, in bulk, to retailers.', slug: 'wholesale'},
  {id: 6, company_type: 'donor', value: 'logistics', name: 'Logistics: Transportation & Warehousing', description: 'The process by which food is supplied to the general population.', slug: 'logistics'},
  {id: 7, company_type: 'donor', value: 'foodservice', name: 'Foodservice (including catering)', description: 'Those businesses, institutions, and companies responsible for any meal prepared outside the home. This industry includes restaurants, school and hospital cafeterias, catering operations, and many other formats.', slug: 'foodservice'},
  {id: 8, company_type: 'donor', value: 'retail', name: 'Retail: Grocery, farmers\' markets, public markets and other retailing', description: '', slug: 'retail'},
  {id: 9, company_type: 'donor', value: 'regulation', name: 'Regulation', description: 'local, regional, national, and international rules and regulations for food production and sale, including food quality, food security, food safety, marketing/advertising, and industry lobbying activities', slug: 'regulation'},
  {id: 10, company_type: 'donor', value: 'education',  name: 'Education', description: 'Academic, consultancy, vocational', slug: 'education'},
  {id: 11, company_type: 'donor', value: 'research_and_development',  name: 'Research and development', description: 'Food technology', slug: 'research-and-development'},
  {id: 12, company_type: 'donor', value: 'financial_services',  name: 'Financial Services', description: 'credit, insurance', slug: 'financial-services'},
  {id: 13, company_type: 'beneficiary', value: 'food_relief', name: "Food Relief", description: '', slug: 'food-relief'},
  {id: 14, company_type: 'beneficiary', value: 'ecd', name: "Early Childhood Development (ECD)", description: '', slug: 'ecd'},
  {id: 14, company_type: 'beneficiary', value: 'church_group', name: "Church Group", description: '', slug: 'church-group'},
  {id: 15, company_type: 'beneficiary', value: 'homeless_support', name: "Homeless Support", description: '', slug: 'homeless-support'},
  {id: 16, company_type: 'beneficiary', value: 'youth_support', name: "Youth support", description: '', slug: 'youth-support'},
  {id: 17, company_type: 'beneficiary', value: 'womens_support', name: "Women's support", description: '', slug: 'womens-support'},
  {id: 18, company_type: 'beneficiary', value: 'disability_support', name: "Disability support", description: '', slug: 'disability-support'},
  {id: 19, company_type: 'beneficiary', value: 'home_of_safety', name: "Home of Safety (Orphange)", description: '', slug: 'home-of-safety'},
  {id: 20, company_type: 'beneficiary', value: 'school', name: "School", description: '', slug: 'school'},
]

export const organisation_types = [
  {name: 'Food Donor'},
  {name: 'Beneficiary Organisation'},
  {name: 'Logistics Partner'},
]

export const featured_organisations = [
  {name: 'Example Org', post_title: 'This is the story title', slug: 'story-title', post_body: 'This is the body of the story. Lorem ipsum etc', img: "/static/images/companies/beneficiary/featured_org_1.jpg"},
  {name: 'Another Example Org', post_title: 'This is another story title', slug: 'story-title-2', post_body: 'This is the body of the story. Lorem ipsum etc', img: "/static/images/companies/beneficiary/featured_org_2.jpg"},
  {name: 'And Another Example Org', post_title: 'This is yet another story title', slug: 'story-title-3', post_body: 'This is the body of the story. Lorem ipsum etc', img: "/static/images/companies/beneficiary/featured_org_3.jpg"},
  {name: 'Yet Another Example Org', post_title: 'Super Great Story', slug: 'super-great-story', post_body: 'This is the body of the story. Lorem ipsum etc', img: "/static/images/companies/beneficiary/featured_org_4.jpg"},

]

export const cities = [
  {name: "Aan de Doorns", province: "Western Cape"},
  {name: "Aberdeen", province: "Eastern Cape"},
  {name: "Aberfeldy", province: "Free State"},
  {name: "Abbotsdale", province: "Western Cape"},
  {name: "Acornhoek", province: "Mpumalanga"},
  {name: "Adelaide", province: "Eastern Cape"},
  {name: "Adendorp", province: "Eastern Cape"},
  {name: "Addo", province: "Eastern Cape"},
  {name: "Aggeneys", province: "Northern Cape"},
  {name: "L'Agulhas or Agulhas", province: "Western Cape"},
  {name: "Ahrens", province: "KwaZulu-Natal"},
  {name: "Akasia", province: "Gauteng"},
  {name: "Albertinia", province: "Western Cape"},
  {name: "Alberton", province: "Gauteng"},
  {name: "Albertshoek", province: "North West"},
  {name: "Alderley", province: "Eastern Cape"},
  {name: "Alexander Bay", province: "Northern Cape"},
  {name: "Alexandria", province: "Eastern Cape"},
  {name: "Alexandra", province: "Gauteng"},
  {name: "Alettasrus", province: "North West"},
  {name: "Alice", province: "Eastern Cape"},
  {name: "Alicedale", province: "Eastern Cape"},
  {name: "Aliwal North", province: "Eastern Cape"},
  {name: "Allandale", province: "Free State"},
  {name: "Allanridge", province: "Free State"},
  {name: "Alldays", province: "Limpopo"},
  {name: "Allep", province: "Free State"},
  {name: "Amalia", province: "North West"},
  {name: "Amalienstein", province: "Western Cape"},
  {name: "Amanzimtoti", province: "KwaZulu-Natal"},
  {name: "Amersfoort", province: "Mpumalanga"},
  {name: "Amsterdam", province: "Mpumalanga"},
  {name: "Anerley", province: "KwaZulu-Natal"},
  {name: "Arlington", province: "Free State"},
  {name: "Arniston", province: "Western Cape"},
  {name: "Ashton", province: "Western Cape"},
  {name: "Askham", province: "Northern Cape"},
  {name: "Atlantis", province: "Western Cape"},
  {name: "Atteridgeville", province: "Gauteng"},
  {name: "Augrabies", province: "Northern Cape"},
  {name: "Aurora", province: "Western Cape"},
  {name: "Baardskeerdersbos", province: "Western Cape"},
  {name: "Babelegi", province: "North West"},
  {name: "Babanango", province: "KwaZulu-Natal"},
  {name: "Badplaas", province: "Mpumalanga"},
  {name: "Bailey", province: "Eastern Cape"},
  {name: "Bakerville", province: "North West"},
  {name: "Balfour", province: "Mpumalanga"},
  {name: "Balfour", province: "Eastern Cape"},
  {name: "Balgowan", province: "KwaZulu-Natal"},
  {name: "Ballengeich", province: "KwaZulu-Natal"},
  {name: "Ballito", province: "KwaZulu-Natal"},
  {name: "Balmoral", province: "Mpumalanga"},
  {name: "Baltimore", province: "Limpopo"},
  {name: "Banana Beach", province: "KwaZulu-Natal"},
  {name: "Bandelierkop", province: "Limpopo"},
  {name: "Bandur", province: "Limpopo"},
  {name: "Bank", province: " Gauteng", province: "Gauteng"},
  {name: "Bankkop", province: "Mpumalanga"},
  {name: "Bapsfontein", province: "Gauteng"},
  {name: "Barakke", province: "Eastern Cape"},
  {name: "Barberspan", province: "North West"},
  {name: "Barberton", province: "Mpumalanga"},
  {name: "Barkly East", province: "Eastern Cape"},
  {name: "Barkly West", province: "Northern Cape"},
  {name: "Baroe", province: "Eastern Cape"},
  {name: "Barrington", province: "Western Cape"},
  {name: "Barrydale", province: "Western Cape"},
  {name: "Bathurst", province: "Eastern Cape"},
  {name: "Baviaan", province: "Western Cape"},
  {name: "Bazley", province: "KwaZulu-Natal"},
  {name: "Beaufort West", province: "Western Cape"},
  {name: "Beauty", province: "Limpopo"},
  {name: "Bedford", province: "Eastern Cape"},
  {name: "Beestekraal", province: "North West"},
  {name: "Behulpsaam", province: "Eastern Cape"},
  {name: "Beitbridge", province: "Limpopo"},
  {name: "Bekker", province: "Northern Cape"},
  {name: "Bela-Bela", province: "Limpopo"},
  {name: "Belfast", province: "Mpumalanga"},
  {name: "Bell", province: "Eastern Cape"},
  {name: "Bellevue", province: "Eastern Cape"},
  {name: "Bellville", province: "Western Cape"},
  {name: "Belmont", province: "Northern Cape"},
  {name: "Benoni", province: "Gauteng"},
  {name: "Berbice", province: "Mpumalanga"},
  {name: "Berea", province: "Western Cape"},
  {name: "Bergplaas", province: "Western Cape"},
  {name: "Bergrivier", province: "Western Cape"},
  {name: "Bergville", province: "KwaZulu-Natal"},
  {name: "Berlin", province: "Eastern Cape"},
  {name: "Bermolli", province: "Northern Cape"},
  {name: "Besters", province: "KwaZulu-Natal"},
  {name: "Bethal", province: "Mpumalanga"},
  {name: "Bethanie", province: "North West"},
  {name: "Bethelsdorp", province: "Eastern Cape"},
  {name: "Bethlehem", province: "Free State"},
  {name: "Bethulie", province: "Free State"},
  {name: "Bettiesdam", province: "Mpumalanga"},
  {name: "Betty's Bay", province: "Western Cape"},
  {name: "Bewley", province: "North West"},
  {name: "Biesiesfontein", province: "Western Cape"},
  {name: "Biesiespoort", province: "Northern Cape"},
  {name: "Biesiesvlei", province: "North West"},
  {name: "Biggarsberg", province: "KwaZulu-Natal"},
  {name: "Bhisho", province: "Eastern Cape"},
  {name: "Bitterfontein", province: "Western Cape"},
  {name: "Bityi", province: "Eastern Cape"},
  {name: "Bloemfontein", province: "Free State"},
  {name: "Bloemhof", province: "North West"},
  {name: "Boipatong", province: "Gauteng"},
  {name: "Boksburg", province: "Gauteng"},
  {name: "Bonnievale", province: "Western Cape"},
  {name: "Bonza Bay", province: "Eastern Cape"},
  {name: "Bophelong", province: "Gauteng"},
  {name: "Bosbokrand", province: "Mpumalanga"},
  {name: "Boshof", province: "Free State"},
  {name: "Boston", province: "KwaZulu-Natal"},
  {name: "Bothaville", province: "Free State"},
  {name: "Botshabelo", province: "Free State"},
  {name: "Brackenfell", province: "Western Cape"},
  {name: "Brakpan", province: "Gauteng"},
  {name: "Brandfort", province: "Free State"},
  {name: "Braunschweig", province: "Eastern Cape"},
  {name: "Bray", province: "North West"},
  {name: "Bredasdorp", province: "Western Cape"},
  {name: "Breyten", province: "Mpumalanga"},
  {name: "Brits", province: "North West"},
  {name: "Britstown", province: "Northern Cape"},
  {name: "Broederstroom", province: "North West"},
  {name: "Bronkhorstspruit", province: "Gauteng"},
  {name: "Buffelsjagbaai", province: "Western Cape"},
  {name: "Bultfontein", province: "Free State"},
  {name: "Bulwer", province: "KwaZulu-Natal"},
  {name: "Burgersdorp", province: "Eastern Cape"},
  {name: "Burgersfort", province: "Limpopo"},
  {name: "Boompie Alleen", province: "Free State"},
  {name: "Butterworth", province: "Eastern Cape"},
  {name: "Cala", province: "Eastern Cape"},
  {name: "Caledon", province: "Western Cape"},
  {name: "Calitzdorp", province: "Western Cape"},
  {name: "Calvert", province: "KwaZulu-Natal"},
  {name: "Calvinia", province: "Northern Cape"},
  {name: "Cambria", province: "Eastern Cape"},
  {name: "Campbell", province: "Northern Cape"},
  {name: "Camperdown", province: "KwaZulu-Natal"},
  {name: "Camps Bay", province: "Western Cape"},
  {name: "Candover", province: "KwaZulu-Natal"},
  {name: "Cannon Rocks", province: "Eastern Cape"},
  {name: "Cape St. Francis", province: "Eastern Cape"},
  {name: "Cape Town", province: "Western Cape"},
  {name: "Cape Vidal", province: "KwaZulu-Natal"},
  {name: "Carletonville", province: "Gauteng"},
  {name: "Carlow", province: "Limpopo"},
  {name: "Carlsonia", province: "North West"},
  {name: "Carlton", province: "Northern Cape"},
  {name: "Carnarvon", province: "Northern Cape"},
  {name: "Carolina", province: "Mpumalanga"},
  {name: "Catalina Bay", province: "KwaZulu-Natal"},
  {name: "Carolusberg", province: "Northern Cape"},
  {name: "Cathcart", province: "Eastern Cape"},
  {name: "Cato Ridge", province: "KwaZulu-Natal"},
  {name: "Cedarville", province: "KwaZulu-Natal"},
  {name: "Centurion", province: "Gauteng"},
  {name: "Ceres", province: "Western Cape"},
  {name: "Chalumna", province: "Eastern Cape"},
  {name: "Chantelle", province: "Gauteng"},
  {name: "Charl Cilliers", province: "Mpumalanga"},
  {name: "Charlestown", province: "KwaZulu-Natal"},
  {name: "Chintsa", province: "Eastern Cape"},
  {name: "Chrissiesmeer", province: "Mpumalanga"},
  {name: "Christiana", province: "North West"},
  {name: "Chuniespoort", province: "Limpopo"},
  {name: "Churchaven", province: "Western Cape"},
  {name: "Citrusdal", province: "Western Cape"},
  {name: "Clansthal", province: "KwaZulu-Natal"},
  {name: "Clanwilliam", province: "Western Cape"},
  {name: "Claremont", province: "Western Cape"},
  {name: "Clarens", province: "Free State"},
  {name: "Clarkebury", province: "Eastern Cape"},
  {name: "Clarkson", province: "Western Cape"},
  {name: "Clermont", province: "KwaZulu-Natal"},
  {name: "Clewer", province: "Mpumalanga"},
  {name: "Clifford", province: "Eastern Cape"},
  {name: "Clifton", province: "Western Cape"},
  {name: "Clocolan", province: "Free State"},
  {name: "Coalville", province: "Mpumalanga"},
  {name: "Coega", province: "Eastern Cape"},
  {name: "Concordia", province: "Northern Cape"},
  {name: "Coffee Bay", province: "Eastern Cape"},
  {name: "Cofimvaba", province: "Eastern Cape"},
  {name: "Coghlan", province: "Eastern Cape"},
  {name: "Colchester", province: "Eastern Cape"},
  {name: "Coleford", province: "Eastern Cape"},
  {name: "Colesberg", province: "Northern Cape"},
  {name: "Colenso", province: "KwaZulu-Natal"},
  {name: "Coligny", province: "North West"},
  {name: "Colston", province: "Northern Cape"},
  {name: "Commondale", province: "Mpumalanga"},
  {name: "Constantia", province: "Western Cape"},
  {name: "Copperton", province: "Northern Cape"},
  {name: "Cornelia", province: "Free State"},
  {name: "Cork", province: "Mpumalanga"},
  {name: "Cookhouse", province: "Eastern Cape"},
  {name: "Cradock", province: "Eastern Cape"},
  {name: "Cullinan", province: "Gauteng"},
  {name: "Dalton", province: "KwaZulu-Natal"},
  {name: "Danielskuil", province: "Northern Cape"},
  {name: "Dannhauser", province: "KwaZulu-Natal"},
  {name: "Darling", province: "Western Cape"},
  {name: "Darnall", province: "KwaZulu-Natal"},
  {name: "Daveyton", province: "Gauteng"},
  {name: "De Aar", province: "Northern Cape"},
  {name: "Dealesville", province: "Free State"},
  {name: "De Doorns", province: "Western Cape"},
  {name: "De Kelders", province: "Western Cape"},
  {name: "Delareyville", province: "North West"},
  {name: "Delmas", province: "Mpumalanga"},
  {name: "Delportshoop", province: "Northern Cape"},
  {name: "Deneysville", province: "Free State"},
  {name: "Derby", province: "North West"},
  {name: "De Rust", province: "Western Cape"},
  {name: "Despatch", province: "Eastern Cape"},
  {name: "Devon", province: "Gauteng"},
  {name: "Dewetsdorp", province: "Free State"},
  {name: "Dibeng", province: "Northern Cape"},
  {name: "Dingleton", province: "Northern Cape"},
  {name: "Döhne", province: "Eastern Cape"},
  {name: "Doonside", province: "KwaZulu-Natal"},
  {name: "Doringbaai", province: "Western Cape"},
  {name: "Dordrecht", province: "Eastern Cape"},
  {name: "Douglas", province: "Northern Cape"},
  {name: "Drummond", province: "KwaZulu-Natal"},
  {name: "Duduza", province: "Gauteng"},
  {name: "Duiwelskloof", province: "Limpopo"},
  {name: "Dullstroom", province: "Mpumalanga"},
  {name: "Dundee", province: "KwaZulu-Natal"},
  {name: "Durban", province: "KwaZulu-Natal"},
  {name: "Durbanville", province: "Western Cape"},
  {name: "Dutywa", province: "Eastern Cape"},
  {name: "Dysselsdorp", province: "Western Cape"},
  {name: "Edenburg", province: "Free State"},
  {name: "Edenvale", province: "Gauteng"},
  {name: "Edenville", province: "Free State"},
  {name: "Eendekuil", province: "Western Cape"},
  {name: "East London", province: "Eastern Cape"},
  {name: "ekuPhakameni", province: "KwaZulu-Natal"},
  {name: "Elandsbaai", province: "Western Cape"},
  {name: "Elandslaagte", province: "KwaZulu-Natal"},
  {name: "Elim", province: "Western Cape"},
  {name: "Elgin", province: "Western Cape"},
  {name: "Elliot", province: "Eastern Cape"},
  {name: "Empangeni", province: "KwaZulu-Natal"},
  {name: "Ermelo", province: "Mpumalanga"},
  {name: "Eshowe", province: "KwaZulu-Natal"},
  {name: "Estcourt", province: "KwaZulu-Natal"},
  {name: "Evaton", province: "Gauteng"},
  {name: "Excelsior", province: "Free State"},
  {name: "Faure", province: "Western Cape"},
  {name: "Fauresmith", province: "Free State"},
  {name: "Ficksburg", province: "Free State"},
  {name: "Firgrove", province: "Western Cape"},
  {name: "Fisherhaven", province: "Western Cape"},
  {name: "Fish Hoek", province: "Western Cape"},
  {name: "Flagstaff", province: "Eastern Cape"},
  {name: "Fochville", province: "Gauteng"},
  {name: "Fort Beaufort", province: "Eastern Cape"},
  {name: "Fouriesburg", province: "Free State"},
  {name: "Frankfort", province: "Free State"},
  {name: "Franklin", province: "KwaZulu-Natal"},
  {name: "Franskraal", province: "Western Cape"},
  {name: "Franschhoek", province: "Western Cape"},
  {name: "Fraserburg", province: "Northern Cape"},
  {name: "Gansbaai", province: "Western Cape"},
  {name: "Ganyesa", province: "North West"},
  {name: "Ga-Rankuwa", province: "North West"},
  {name: "Gcuwa", province: "Eastern Cape"},
  {name: "Genadendal", province: "Western Cape"},
  {name: "George", province: "Western Cape"},
  {name: "Germiston", province: "Gauteng"},
  {name: "Giyani", province: "Limpopo"},
  {name: "Glencoe", province: "KwaZulu-Natal"},
  {name: "Gonubie", province: "Eastern Cape"},
  {name: "Gordon's Bay", province: "Western Cape"},
  {name: "Gouda", province: "Western Cape"},
  {name: "Graaff-Reinet", province: "Eastern Cape"},
  {name: "Graafwater", province: "Western Cape"},
  {name: "Grabouw", province: "Western Cape"},
  {name: "Grahamstown", province: "Eastern Cape"},
  {name: "Graskop", province: "Mpumalanga"},
  {name: "Gravelotte", province: " Limpopo", province: "Limpopo"},
  {name: "Greylingstad", province: "Mpumalanga"},
  {name: "Greyton", province: "Western Cape"},
  {name: "Greytown", province: "KwaZulu-Natal"},
  {name: "Griekwastad", province: "Northern Cape"},
  {name: "Groblersdal", province: "Limpopo"},
  {name: "Groblershoop", province: "Northern Cape"},
  {name: "Groot Marico", province: "North West"},
  {name: "Haenertsburg", province: "Limpopo"},
  {name: "Hammanskraal", province: "Gauteng"},
  {name: "Hankey", province: "Eastern Cape"},
  {name: "Harrismith", province: "Free State"},
  {name: "Hartbeespoort", province: "North West Province"},
  {name: "Hattingspruit", province: "KwaZulu-Natal"},
  {name: "Hazyview", province: "Mpumalanga"},
  {name: "Hectorspruit", province: "Mpumalanga"},
  {name: "Heidelberg", province: "Gauteng"},
  {name: "Heidelberg", province: "Western Cape"},
  {name: "Heilbron", province: "Free State"},
  {name: "Henley on Klip", province: "Gauteng"},
  {name: "Hennenman", province: "Free State"},
  {name: "Hermanus", province: "Western Cape"},
  {name: "Hertzogville", province: "Free State"},
  {name: "Hibberdene", province: "KwaZulu-Natal"},
  {name: "Hillcrest", province: "KwaZulu-Natal"},
  {name: "Hilton", province: "KwaZulu-Natal"},
  {name: "Himeville", province: "KwaZulu-Natal"},
  {name: "Hluhluwe", province: "KwaZulu-Natal"},
  {name: "Hobhouse", province: "Free State"},
  {name: "Hoedspruit", province: "Limpopo"},
  {name: "Hofmeyr", province: "Eastern Cape"},
  {name: "Hoopstad", province: "Free State"},
  {name: "Hopefield", province: "Western Cape"},
  {name: "Hopetown", province: "Northern Cape"},
  {name: "Howick", province: "KwaZulu-Natal"},
  {name: "Humansdorp", province: "Eastern Cape"},
  {name: "Ifafa Beach", province: "KwaZulu-Natal"},
  {name: "Illovo Beach", province: "KwaZulu-Natal"},
  {name: "Indwe", province: "Eastern Cape"},
  {name: "Impendle", province: "KwaZulu-Natal"},
  {name: "Inanda", province: "KwaZulu-Natal"},
  {name: "Ingwavuma", province: "KwaZulu-Natal"},
  {name: "Irene", province: "Gauteng"},
  {name: "Isando", province: "Gauteng"},
  {name: "Isipingo", province: "KwaZulu-Natal"},
  {name: "Ixopo", province: "KwaZulu-Natal"},
  {name: "Jansenville", province: "Eastern Cape"},
  {name: "Jacobsdal", province: "Free State"},
  {name: "Jagersfontein", province: "Free State"},
  {name: "Jan Kempdorp", province: "Northern Cape"},
  {name: "Jeffreys Bay", province: "Eastern Cape"},
  {name: "Johannesburg", province: "Gauteng"},
  {name: "Kaapmuiden", province: "Mpumalanga"},
  {name: "Karridene", province: "KwaZulu-Natal"},
  {name: "Katlehong", province: "Gauteng"},
  {name: "Kempton Park", province: "Gauteng"},
  {name: "Kenton-on-Sea", province: "Eastern Cape"},
  {name: "Kestell", province: "Free State"},
  {name: "Keurboomstrand", province: "Western Cape"},
  {name: "Kgotsong", province: "Free State"},
  {name: "Khayelitsha", province: "Western Cape"},
  {name: "Kimberley", province: "Northern Cape"},
  {name: "Kingsburgh", province: "KwaZulu-Natal"},
  {name: "King William's Town", province: "Eastern Cape"},
  {name: "Kinross", province: "Mpumalanga"},
  {name: "Kirkwood", province: "Eastern Cape"},
  {name: "Klerksdorp", province: "North West Province"},
  {name: "Kloof", province: "KwaZulu-Natal"},
  {name: "Knysna", province: "Western Cape"},
  {name: "Koffiefontein", province: "Free State"},
  {name: "Kokstad", province: "KwaZulu-Natal"},
  {name: "Komatipoort", province: "Mpumalanga"},
  {name: "Kommetjie", province: "Western Cape"},
  {name: "Koppies", province: "Free State"},
  {name: "Kraaifontein", province: "Western Cape"},
  {name: "Kromdraai", province: "Gauteng"},
  {name: "Kroonstad", province: "Free State"},
  {name: "Kriel", province: "Mpumalanga"},
  {name: "Krugersdorp", province: "Gauteng"},
  {name: "Kuils River", province: "Western Cape"},
  {name: "KwaDukuza", province: "KwaZulu-Natal"},
  {name: "KwaMashu", province: "KwaZulu-Natal"},
  {name: "KwaMhlanga", province: "Mpumalanga"},
  {name: "KwaThema", province: "Gauteng"},
  {name: "Ladybrand", province: "Free State"},
  {name: "Lady Frere", province: "Eastern Cape"},
  {name: "Lady Grey", province: "Eastern Cape"},
  {name: "Ladysmith", province: "KwaZulu-Natal"},
  {name: "Laingsburg", province: "Western Cape"},
  {name: "La Lucia", province: "KwaZulu-Natal"},
  {name: "La Mercy", province: "KwaZulu-Natal"},
  {name: "Lambert's Bay", province: "Western Cape"},
  {name: "Lenasia", province: "Gauteng"},
  {name: "Lephalale", province: "Limpopo"},
  {name: "Lichtenburg", province: "North West"},
  {name: "Lindley", province: "Free State"},
  {name: "Lyttelton", province: "Gauteng"},
  {name: "Loopspruit", province: "Mpumalanga"},
  {name: "Louis Trichardt", province: "Limpopo"},
  {name: "Louwsburg", province: "KwaZulu-Natal"},
  {name: "Luckhoff", province: "Free State"},
  {name: "Lydenburg", province: "Mpumalanga"},
  {name: "Machadodorp", province: "Mpumalanga"},
  {name: "Maclear", province: "Eastern Cape"},
  {name: "Madadeni", province: "Eastern Cape"},
  {name: "Mafikeng", province: "North West"},
  {name: "Magabeni", province: "KwaZulu-Natal"},
  {name: "Magaliesburg", province: "Gauteng"},
  {name: "Mahlabatini", province: "KwaZulu-Natal"},
  {name: "Makeleketla", province: "Free State"},
  {name: "Malelane", province: "Mpumalanga"},
  {name: "Mamelodi", province: "Gauteng"},
  {name: "Mandini", province: "Eastern Cape"},
  {name: "Marble Hall", province: "Limpopo"},
  {name: "Margate", province: "KwaZulu-Natal"},
  {name: "Marquard", province: "Free State"},
  {name: "Matatiele", province: "Eastern Cape"},
  {name: "Matjiesfontein", province: "Western Cape"},
  {name: "Mbombela", province: "Mpumalanga"},
  {name: "Melkbosstrand", province: "Western Cape"},
  {name: "Melmoth", province: "KwaZulu-Natal"},
  {name: "Memel", province: "Free State"},
  {name: "Merrivale", province: "KwaZulu-Natal"},
  {name: "Meyerton", province: "Gauteng"},
  {name: "Middelburg", province: "Eastern Cape"},
  {name: "Middelburg", province: "Mpumalanga"},
  {name: "Midrand", province: "Gauteng"},
  {name: "Mkuze", province: "KwaZulu-Natal"},
  {name: "Mmabatho", province: "North West Province"},
  {name: "Modder River", province: "Northern Cape"},
  {name: "Modimolle", province: "Limpopo"},
  {name: "Mokopane", province: "Limpopo"},
  {name: "Molteno", province: "Eastern Cape"},
  {name: "Mooirivier", province: "KwaZulu-Natal"},
  {name: "Morgenzon", province: "Mpumalanga"},
  {name: "Mount Edgecombe", province: "KwaZulu-Natal"},
  {name: "Mount Fletcher", province: "Eastern Cape"},
  {name: "Mossel Bay", province: "Western Cape"},
  {name: "Mthatha", province: "Eastern Cape"},
  {name: "Mtubatuba", province: "KwaZulu-Natal"},
  {name: "Mtunzini", province: "KwaZulu-Natal"},
  {name: "Muden", province: "KwaZulu-Natal"},
  {name: "Muizenberg", province: "Western Cape"},
  {name: "Muldersdrift", province: "Gauteng"},
  {name: "Musina", province: "Limpopo"},
  {name: "Naboomspruit", province: "Limpopo"},
  {name: "Newcastle", province: "KwaZulu-Natal"},
  {name: "New Germany", province: "KwaZulu-Natal"},
  {name: "New Hanover", province: "KwaZulu-Natal"},
  {name: "Engcobo", province: "Eastern Cape"},
  {name: "Nieu-Bethesda", province: "Eastern Cape"},
  {name: "Nigel", province: "Gauteng"},
  {name: "Nongoma", province: "KwaZulu-Natal"},
  {name: "Noordhoek", province: "Western Cape"},
  {name: "Nottingham Road", province: "KwaZulu-Natal"},
  {name: "Odendaalsrus", province: "Free State"},
  {name: "Ogies", province: "Mpumalanga"},
  {name: "Ohrigstad", province: "Mpumalanga"},
  {name: "Orania", province: " Northern Cape", province: "Northern Cape"},
  {name: "Oranjeville", province: "Free State"},
  {name: "Orchards", province: "Gauteng"},
  {name: "Orkney", province: "North West"},
  {name: "Oudtshoorn", province: "Western Cape"},
  {name: "Oyster Bay", province: "Eastern Cape"},
  {name: "Paarl", province: "Western Cape"},
  {name: "Palm Beach", province: "KwaZulu-Natal"},
  {name: "Park Rynie", province: "KwaZulu-Natal"},
  {name: "Parys", province: "Free State"},
  {name: "Patensie", province: "Eastern Cape"},
  {name: "Paterson", province: "Eastern Cape"},
  {name: "Paulpietersburg", province: "KwaZulu-Natal"},
  {name: "Paul Roux", province: "Free State"},
  {name: "Pennington", province: "KwaZulu-Natal"},
  {name: "Perdekop", province: "Mpumalanga"},
  {name: "Petrusburg", province: "Free State"},
  {name: "Petrus Steyn", province: "Free State"},
  {name: "Phalaborwa", province: "Limpopo"},
  {name: "Philippolis", province: "Free State"},
  {name: "Phuthaditjhaba", province: "Free State"},
  {name: "Piet Retief", province: "Mpumalanga"},
  {name: "Pietermaritzburg", province: "KwaZulu-Natal"},
  {name: "Piketberg", province: "Western Cape"},
  {name: "Pilgrim's Rest", province: "Mpumalanga"},
  {name: "Pinetown", province: "KwaZulu-Natal"},
  {name: "Plettenberg Bay", province: "Western Cape"},
  {name: "Pniel", province: "Western Cape"},
  {name: "Polokwane", province: "Limpopo"},
  {name: "Pomeroy", province: "KwaZulu-Natal"},
  {name: "Pongola", province: "KwaZulu-Natal"},
  {name: "Port Alfred", province: "Eastern Cape"},
  {name: "Port Edward", province: "KwaZulu-Natal"},
  {name: "Port Elizabeth", province: "Eastern Cape"},
  {name: "Port Shepstone", province: "KwaZulu-Natal"},
  {name: "Port St. Johns", province: "Eastern Cape"},
  {name: "Potchefstroom", province: "North West"},
  {name: "Pretoria", province: "Gauteng"},
  {name: "Prieska", province: "Northern Cape"},
  {name: "Prins Albert", province: "Western Cape"},
  {name: "Queensburgh", province: "KwaZulu-Natal"},
  {name: "Queenstown", province: "Eastern Cape"},
  {name: "Ramsgate", province: "KwaZulu-Natal"},
  {name: "Randburg", province: "Gauteng"},
  {name: "Randfontein", province: "Gauteng"},
  {name: "Ratanda", province: "Gauteng"},
  {name: "Reddersburg", province: "Free State"},
  {name: "Reitz", province: "Free State"},
  {name: "Richards Bay", province: "KwaZulu-Natal"},
  {name: "Richmond", province: "Northern Cape"},
  {name: "Riebeek Kasteel", province: "Western Cape"},
  {name: "Robertson", province: "Western Cape"},
  {name: "Roodepoort", province: "Gauteng"},
  {name: "Rooihuiskraal", province: "Gauteng"},
  {name: "Rosendal", province: "Free State"},
  {name: "Rouxville", province: "Free State"},
  {name: "Rustenburg", province: "North West"},
  {name: "Sabie", province: "Mpumalanga"},
  {name: "Salt Rock", province: "KwaZulu-Natal"},
  {name: "Sandton", province: "Gauteng"},
  {name: "Sannieshof", province: "North West"},
  {name: "Sasolburg", province: "Free State"},
  {name: "Schweizer-Reneke", province: "North West"},
  {name: "Scottburgh", province: "KwaZulu-Natal"},
  {name: "Sebokeng", province: "Gauteng"},
  {name: "Secunda", province: "Mpumalanga"},
  {name: "Senekal", province: "Free State"},
  {name: "Sezela", province: "KwaZulu-Natal"},
  {name: "Sharpeville", province: "Gauteng"},
  {name: "Shawela", province: "Limpopo"},
  {name: "Shelly Beach", province: "KwaZulu-Natal"},
  {name: "Smithfield", province: "Free State"},
  {name: "Somerset East", province: "Eastern Cape"},
  {name: "Somerset West", province: "Western Cape"},
  {name: "Soshanguve", province: "Gauteng"},
  {name: "Southbroom", province: "KwaZulu-Natal"},
  {name: "Soweto", province: "Gauteng"},
  {name: "Springbok", province: "Northern Cape"},
  {name: "Springfontein", province: "Free State"},
  {name: "Springs", province: "Gauteng"},
  {name: "Standerton", province: "Mpumalanga"},
  {name: "Stilfontein", province: "North West"},
  {name: "Stellenbosch", province: "Western Cape"},
  {name: "Steynsburg", province: "Eastern Cape"},
  {name: "Steynsrus", province: "Free State"},
  {name: "St Francis Bay", province: "Eastern Cape"},
  {name: "St Lucia", province: "KwaZulu-Natal"},
  {name: "St Michael's-on-sea", province: "KwaZulu-Natal"},
  {name: "Strand", province: "Western Cape"},
  {name: "Strydenburg", province: "Northern Cape"},
  {name: "Stutterheim", province: "Eastern Cape"},
  {name: "Swartberg", province: "Western Cape"},
  {name: "Swellendam", province: "Western Cape"},
  {name: "Swinburne", province: "Free State"},
  {name: "Tarkastad", province: "Eastern Cape"},
  {name: "Tembisa", province: "Gauteng"},
  {name: "Thaba Nchu", province: "Free State"},
  {name: "Thabazimbi", province: "Limpopo"},
  {name: "Theunissen", province: "Free State"},
  {name: "Thohoyandou", province: "Limpopo"},
  {name: "Thokoza", province: "Gauteng"},
  {name: "Tongaat", province: "KwaZulu-Natal"},
  {name: "Trichardt", province: "Mpumalanga"},
  {name: "Trompsburg", province: "Free State"},
  {name: "Tsakane", province: "Gauteng"},
  {name: "Tugela Ferry", province: "KwaZulu-Natal"},
  {name: "Tulbagh", province: "Western Cape"},
  {name: "Tweeling", province: "Free State"},
  {name: "Tweespruit", province: "Free State"},
  {name: "Ubombo", province: "KwaZulu-Natal"},
  {name: "Uitenhage", province: "Eastern Cape"},
  {name: "Ulundi", province: "KwaZulu-Natal"},
  {name: "Umbongintwini", province: "KwaZulu-Natal"},
  {name: "Umdloti", province: "KwaZulu-Natal"},
  {name: "Umgababa", province: "KwaZulu-Natal"},
  {name: "Umhlanga Rocks", province: "KwaZulu-Natal"},
  {name: "Umkhomazi", province: "KwaZulu-Natal"},
  {name: "Umlazi", province: "KwaZulu-Natal"},
  {name: "Umtentweni", province: "KwaZulu-Natal"},
  {name: "Umthatha", province: "Eastern Cape"},
  {name: "Umzinto", province: "KwaZulu-Natal"},
  {name: "Umzumbe", province: "KwaZulu-Natal"},
  {name: "Underberg", province: "KwaZulu-Natal"},
  {name: "Upington", province: "Northern Cape"},
  {name: "Uniondale", province: " Western Cape", province: "Western Cape"},
  {name: "Utrecht", province: "KwaZulu-Natal"},
  {name: "Uvongo", province: "KwaZulu-Natal"},
  {name: "Vaalbank", province: "Mpumalanga"},
  {name: "Vaalwater", province: "Limpopo"},
  {name: "Vanderbijlpark", province: "Gauteng"},
  {name: "Van Reenen", province: "KwaZulu-Natal"},
  {name: "Van Stadensrus", province: "Free State"},
  {name: "Ventersburg", province: "Free State"},
  {name: "Vereeniging", province: "Gauteng"},
  {name: "Verkeerdevlei", province: "Free State"},
  {name: "Verulam", province: "KwaZulu-Natal"},
  {name: "Victoria West", province: "Northern Cape"},
  {name: "Viljoenskroon", province: "Free State"},
  {name: "Villiers", province: "Free State"},
  {name: "Virginia", province: "KwaZulu-Natal"},
  {name: "Vivo", province: "Limpopo"},
  {name: "Volksrust", province: "Mpumalanga"},
  {name: "Vosloorus", province: "Gauteng"},
  {name: "Vrede", province: "Free State"},
  {name: "Vredefort", province: "Free State"},
  {name: "Vryburg", province: "North West"},
  {name: "Vryheid", province: "KwaZulu-Natal"},
  {name: "Wakkerstroom", province: "Mpumalanga"},
  {name: "Warden", province: "Free State"},
  {name: "Warner Beach", province: "KwaZulu-Natal"},
  {name: "Warrenton", province: "Northern Cape"},
  {name: "Wartburg", province: "KwaZulu-Natal"},
  {name: "Wasbank", province: "KwaZulu-Natal"},
  {name: "Waterval Boven", province: "Mpumalanga"},
  {name: "Waterval Onder", province: "Mpumalanga"},
  {name: "Wedela", province: "Gauteng[1]"},
  {name: "Weenen", province: "KwaZulu-Natal"},
  {name: "Welkom", province: "Free State"},
  {name: "Wellington", province: "Western Cape"},
  {name: "Wepener", province: "Free State"},
  {name: "Wesselsbron", province: "Free State"},
  {name: "Westonaria", province: "Gauteng"},
  {name: "Westville", province: "KwaZulu-Natal"},
  {name: "White River", province: "Mpumalanga"},
  {name: "Whittlesea", province: "Eastern Cape"},
  {name: "Wilderness", province: "Western Cape"},
  {name: "Williston", province: "Northern Cape"},
  {name: "Winburg", province: "Free State"},
  {name: "Winkelspruit", province: "KwaZulu-Natal"},
  {name: "Winterton", province: "KwaZulu-Natal"},
  {name: "Witbank", province: "Mpumalanga"},
  {name: "Wolmaransstad", province: "North West"},
  {name: "Worcester", province: "Western Cape"},
  {name: "York", province: "KwaZulu-Natal"},
  {name: "Yzerfontein", province: "Western Cape"},
  {name: "Zastron", province: "Free State"},
  {name: "Zeerust", province: "North West"},
  {name: "Zwelitsha", province: "Eastern Cape"},
]

export const donor_dashboard_list = [{
  last_parcel: {
    parcel_id: '', // uuid
    donation_date: '', // float (3 decimal places)
    weight: '', // float (2 decimal places)
    meals: '', // float (2 decimal places)
    rand_value: '', //float (2 decimal places)
  },
  total_parcels_count: '', // int
  total_parcels_weight: '', // kg float (3 decimal places)
  total_parcels_meals: '', //float (2 decimal places)
  total_parcels_rand_value: '',
  total_open_tickets: '', //int
}]

const donor_dashboard_map_markers = [
  {
    company_id: '',
    company_type: '',
    latitude: '',
    longitude: '',
    last_parcel_received: {
      parcel_id: '', // uuid
      parcel_products: [
        {
          name: '',
          quantity: '',
          best_before_date: '',
          expiry_date: '',
          product_item_weight: '',
          total_weight: '', // last_parcel_received.parcel_products.quantity * product_item_weight
        }
      ],
      parcel_donation_date: '', // datetime
      parcel_weight: '', // float (3 decimal places)
      parcel_meals: '', // float (2 decimal places)
      parcel_rand_value: '', //float (2 decimal places)
    },
    total_parcels_count: '', // int
    total_parcels_weight: '', // kg float (3 decimal places)
    total_parcels_meals: '', //float (2 decimal places)
    total_parcels_rand_value: '',
  }
]

export const contactParcelList = [
  {
    id: 'a578e3c3-d8b3-4620-8934-4b8b445ca788',
    short_ref: 'a578e3c3',
    created_at: '2021-09-27T14:04:04.565903+02:00',
    description: null,
    from_company: '45b29b61-c1dc-4c54-a657-6a0830b73c55',
    to_company: null,
    depart_at: '2021-09-29T16:00:00+02:00',
    arrive_at: null,
    total_weight_kg: 23,
    override_total_value_rands: true,
    override_total_weight_kg: true,
    total_value_rands: 370,
    num_meals: 76.66666658999999,
    from_company_name: 'Bentleys Bread Co',
    depart_warehouse: null,
    arrive_warehouse: null,
    driver: null,
    driver_status: 'unassigned',
    direction: 'donor_pickup',
    status: 'pending',
    parcel_products: [
      {
        id: 'd43d6e70-aa3e-40a5-9d1d-9532f8f3ec0e',
        product: 'b820acf5-4cec-4dd3-adf5-4bd28eb12973',
        parcel: 'a578e3c3-d8b3-4620-8934-4b8b445ca788',
        total_weight_kg: 5,
        total_value_rands: 300,
        product_category_crumbs: [],
        best_before_date: null,
        expiry_date: null,
        provisional_quantity: 3,
        actual_quantity: null,
        created_at: '2021-09-27T14:04:05.111793+02:00',
        product_name: '1000 ISLAND DRESSING 12 X 375 ML STE'
      },
      {
        id: 'b2be889e-38e7-4173-b510-bafe22edcb43',
        product: 'f60e3556-7534-4206-8854-5dd584d9c071',
        parcel: 'a578e3c3-d8b3-4620-8934-4b8b445ca788',
        total_weight_kg: 6,
        total_value_rands: 25,
        product_category_crumbs: [],
        best_before_date: null,
        expiry_date: null,
        provisional_quantity: 5,
        actual_quantity: null,
        created_at: '2021-09-27T14:04:05.128291+02:00',
        product_name: '10 BAGASSE EMBOSSED CONTAINER PER 200 WIM'
      },
      {
        id: 'ed846e52-732f-4150-bd4e-96fae78c89a5',
        product: 'a7fa8164-a241-4927-8242-1f347e6b8a26',
        parcel: 'a578e3c3-d8b3-4620-8934-4b8b445ca788',
        total_weight_kg: 12,
        total_value_rands: 45,
        product_category_crumbs: [],
        best_before_date: null,
        expiry_date: null,
        provisional_quantity: 7,
        actual_quantity: null,
        created_at: '2021-09-27T14:04:05.148092+02:00',
        product_name: '1 2 CHIC DUPLEX BAG 164 X 265 PER 1000 NET'
      }
    ],
    company_invoice_file_info: {
      id: '3fca9c2c-57f3-4e20-abf1-68183ea1fcf1',
      original_download_url: 'http://localhost:8009/media/uploads/87c119c1-41ff-4b4d-9e53-4a58b919607a/M1M_Branch_List.pdf',
      content_type: 'application/pdf',
      size_bytes: 0,
      sequence: null,
      original_filename: 'M1M Branch List.pdf',
      visible_filename: 'M1M Branch List.pdf'
    },
    delivery_notes: null,
    company_invoice_is_valid: null,
    qualifies_for_section18_certificate: false,
    section18_certificate_report_generation: null,
    parcel_products_value_rands: 370,
    parcel_products_weight_kg: 23,
    parcel_products_meals: 76.66666658999999,
    transport_by_warehouse_company: true,
    depart_address: null,
    arrive_address: null,
    province: null
  }
]


const donor_donations_distribution_list = [
  {
    to_company: "f94074d5-5e2f-40f0-92b5-f63dbaf2b15a", // beneficiary company id
    to_company_name: "Super awesome beneficiary",                       // beneficiary company name
    parcel_id: "1f2263f7-095d-460e-9d06-62912534ec60",
    parcel_short_ref: "1f2263f7",
    parcel_value_rands: false, // override rand value of products in this parcel relative only to products from the donor company
    parcel_weight_kg: null, // weight of products in this parcel only from the donor company
    parcel_meals: null, // meals equivalent of this parcel relative only to products from the donor company
    parcel_status: "pending",
    parcel_products: {
      product_id: 3,
      product_name: '',
      quantity: 3,
      item_weight: 3.5,
      total_weight: '', // parcel_products.quantity * item_weight
      best_before_date: '',
      expiry_date: '',
    },
    override_total_value_rands: false, // override rand value of products in this parcel relative only to products from the donor company
    override_total_weight_kg: false, // weight  products in this parcel relative only to products from the donor company
    arrive_address: "26 East Anglia Drive, Morningside, Pretoria, South Africa", // Google formatted address
    arrive_at: "2021-05-14T00:00:00+02:00",
    created_at: "2021-05-13T14:51:25.489267+02:00",
    depart_at: "2021-05-14T00:00:00+02:00",
    description: null,
    direction: "beneficiary_dropoff", // will always be beneficiary_dropoff for donations_distribution_list
    transport_by_warehouse_company: true,
    driver_name: 'Ben Molefe',
    driver_id: '1g3373f7-095d-460e-9d06-62912534ec60',
  }
]

const beneficiary_received_parcels_list = [
  {
    from_company_id: "2ff0122d-1e6a-42fa-8bb3-e50670aba9cc", // "should always be company associated with logged in user
    from_company_name: "Example Donor", // "should always be company associated with logged in user
    parcel_id: "1f2263f7-095d-460e-9d06-62912534ec60",
    parcel_short_ref: "1f2263f7",
    parcel_value_rands: null,
    parcel_weight_kg: null,
    parcel_meals: null,
    parcel_status: "pending",
    parcel_products: {
      product_id: 3,
      product_name: '',
      quantity: 3,
      item_weight: 3.5,
      total_weight: '', // quantity * item_weight
      best_before_date: '',
      expiry_date: '',
      value_rands: '',
    },
    override_total_value_rands: false,
    override_total_weight_kg: false,
    arrive_address: null,
    arrive_at: null,
    arrive_warehouse: "c7ebf802-f530-4344-b552-80bcb34f9522",
    arrive_warehouse_name: "PRIMI",
    created_at: "2021-05-13T14:51:25.489267+02:00",
    depart_at: "2021-05-14T00:00:00+02:00",
    description: null,
    direction: "donor_pickup",
    transport_by_warehouse_company: true,
    driver: null,
    to_company: "f94074d5-5e2f-40f0-92b5-f63dbaf2b15a",
    to_company_name: "SAHarvest",
  }]

  export const campaigns = [{
    id: '',
    name: '',
    campaign_type: '', // options: ["petition", "fund_raising", "competition"]
    slug: '',
    hashtag: '',
    description: '',
    image_url: '',
    start_date: '',
    end_date: '',
    status: '',
  }]
  export const petition_submissions = [{
    id: '',
    campaign: '',
    petitioner: {
      first_name: '',
      last_name: '',
      email: '',
      cell_number: '',
    },
    message: '',
    image_url: ''
  }]
